import { create as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { handleSubscribers as t } from "@magnopus-opensource/connected-spaces-platform-web-api";
//#region src/lib/store/featureFlagsStore.ts
var n = /* @__PURE__ */ new Map([
	["guest_login", !1],
	["public_spaces", !1],
	["release_notes", !1],
	["signup_allowed", !1],
	["translations", !1],
	["asset_security", !1]
]), r = /* @__PURE__ */ new Map([
	["ai_chatbot", !0],
	["ar_mode", !0],
	["asset_cache", !1],
	["asset_security", !0],
	["assets_folder_navigation", !1],
	["auto_enable_advanced_graphics_features", !0],
	["chat", !0],
	["comments", !0],
	["communications", !0],
	["custom_avatars", !0],
	["custom_components", !1],
	["directional_light", !1],
	["entity_locking", !0],
	["favourite_spaces", !1],
	["featured_spaces", !1],
	["generative_ai", !0],
	["generative_ai_look_gen", !0],
	["generative_scripting", !0],
	["geolocated_spaces", !0],
	["hotspots", !0],
	["import_punctual_lights", !1],
	["light_cookies", !1],
	["measurement_tool", !0],
	["nodey", !0],
	["parallel_graphql_queries", !0],
	["screen_sharing", !0],
	["settings", !0],
	["space_snapshot", !1],
	["ssao", !1],
	["video_light_cookies", !1],
	["vr_mode", !0]
]), i = e((e) => ({
	anonFeatureFlags: /* @__PURE__ */ new Map(),
	authFeatureFlags: /* @__PURE__ */ new Map(),
	availableAiModels: [],
	setAnonFeatureFlags: (t) => e(() => ({ anonFeatureFlags: t })),
	setAuthFeatureFlags: (t) => e(() => ({ authFeatureFlags: t })),
	setAvailableAiModels: (t) => e(() => ({ availableAiModels: t }))
}));
t(i);
//#endregion
export { n as defaultAnonymousFlags, r as defaultAuthenticatedFlags, i as featureFlagStore };
